import { createSlice } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IInquiry } from "src/@types/inquiries";
import { INQUIRIES_SLICE_NAME } from "./actions";
import {
  getInquiriesReducer,
  getSimilarInquiriesReducer,
} from "./reducers";

interface IInquiriesObject<T> {
  isLoading: boolean;
  data: T;
}

export interface IInquiriesState {
  inquiries: IInquiriesObject<IResponseWithPagination<IInquiry>>;
  similarInquiries: IInquiriesObject<IInquiry[]>;
}

const initialState: IInquiriesState = {
  inquiries: {
    isLoading: false,
    data: null,
  },
  similarInquiries: {
    isLoading: false,
    data: null,
  },
};

export const { reducer: inquiries } = createSlice({
  name: INQUIRIES_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getInquiriesReducer(builder);
    getSimilarInquiriesReducer(builder);
  },
});
